import type { Agent } from '@tunasong/schemas'

/** The fields a band owns on an agent (spec #2365 §1). Runtime writes (memory, lastRunAt, status) are not among them. */
export const personaFields = ['name', 'voice', 'instructions'] as const
export type PersonaField = (typeof personaFields)[number]

type Persona = Pick<Agent, PersonaField>

/** Unset, null (cleared) and blank all read as "nothing set" */
const normalise = (value: string | null | undefined) => value?.trim() ?? ''

/**
 * The persona fields someone else changed since the edit form opened (spec #2365 §3a). An empty list means
 * saving cannot overwrite anyone. The agent's own runtime writes never count: a whole-entity version check
 * would report a conflict on every turn the agent took while the form was open.
 */
export const personaChangedSince = (opened: Persona, current: Persona): PersonaField[] =>
  personaFields.filter(field => normalise(opened[field]) !== normalise(current[field]))
